import React, { useState, useEffect } from 'react'
import Button from 'components/common/Button'
// import TextInputElement from 'components/forms/TextInputElement'
import { useSelector, useDispatch } from 'react-redux'
import { pushChannel } from 'services/websocket'
import { eventSelector, chatSelector } from 'src/selectors'
import { ROOM_CHANNEL_TYPES_CONSTANTS } from 'src/constants'
import { Mentions } from 'antd'
import { fetchGroupGuests } from 'src/actions/eventChat'
import uuid from 'uuid/v4'
import PropTypes from 'prop-types'
import debounce from 'lodash/debounce'

import styles from './input-message.scss'

const optionStyle = {
  display: 'flex',
  alignItems: 'center',
  padding: '10px 0',
  gap: 20
}

const InputMessage = props => {
  const { inReply, message = null } = props
  const dispatch = useDispatch()
  const event = useSelector(eventSelector)
  const chat = useSelector(chatSelector)
  const [messageContent, setMessageContent] = useState('')
  const [tagList, setTagList] = useState({})
  const mapGroupList = chat.groupList.map(group => ({
    key: group.id,
    value: group.id,
    text: group.name,
    label: (
      <div style={optionStyle}>
        <div style={{ fontWeight: 500 }}>{group.name}</div>
        <div style={{ fontSize: '14px', color: '#9099a7' }}>
          {group.count} people · {group.info_text}
        </div>
      </div>
    )
  }))

  useEffect(() => {
    dispatch(
      fetchGroupGuests({
        groupId: event.external_room_id
      })
    )
  }, [])

  const handleSendMessage = debounce(() => {
    // format tag user.
    const messageBody = messageContent.replace(/@\w+/g, match => tagList[match])
    console.log(messageBody)

    const payload = {
      id: uuid(),
      type: 'chat',
      message_parts: [
        {
          id: uuid(),
          type: 'text',
          body: messageBody
        }
      ]
    }

    if (inReply) {
      payload.thread_id = message.id
    }

    if (chat.socketInstance.isConnected()) {
      pushChannel({
        channelName: event.messages_channel,
        action: ROOM_CHANNEL_TYPES_CONSTANTS.create_new_message,
        payload,
        successCallback: () => {
          setMessageContent('')
          setTagList({})
        }
      })
    }
  }, 200)

  const handleKeyDown = e => {
    if (e.key === 'Enter') {
      if (e.ctrlKey) {
        // 在文本框中添加换行符
        setMessageContent(messageContent + '\n')
      }

      e.preventDefault()
      if (messageContent) {
        // console.log('send：', messageContent)
        // 发送消息逻辑
        // sendMessage()
      }
    }
  }

  const handleSelect = option => {
    const { groupName, id, name } = chat.groupList.find(item => item.id === option.value)
    let str = `<${groupName}:${id}|@${name}>`
    const key = `@${name}`
    setTagList({ ...tagList, [key]: str })

    setMessageContent(messageContent + `${name} `)
  }

  return (
    <div className={styles['input-message-container']}>
      {/* <div className={styles['input-container']}>
        <TextInputElement
          className={styles['input-inner']}
          onChange={event => setMessageContent(event.target.value)}
          valid
          value={messageContent}
          placeholder="Join to comment..."
          onKeyDown={e => {
            if (e.key === 'Enter' && messageContent) {
              handleSendMessage()
            }
          }}
        />
      </div> */}

      <Mentions
        value={messageContent}
        autoSize={{ minRows: 1, maxRows: 2 }}
        onChange={value => setMessageContent(value)}
        onKeyDown={handleKeyDown}
        onSelect={handleSelect}
        options={mapGroupList}
      />

      <Button
        disabled={!messageContent}
        className={styles['send-button']}
        onClick={handleSendMessage}
      >
        SEND
      </Button>
    </div>
  )
}

InputMessage.propTypes = {
  inReply: PropTypes.bool,
  message: PropTypes.object
}

export default InputMessage
